import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, Stack } from '@mui/material';

import Logo from 'components/Logo/Logo';

import { AppRoutes } from 'enums/routes.enum';

import { DesktopMenuContainer, DesktopMenuWrapper } from './Menu.styled';

const DesktopMenu = () => {
    return (
        <DesktopMenuWrapper>
            <DesktopMenuContainer maxWidth="lmg">
                <Logo height={'32px'} fontSize="18px" />
                <Stack direction="row" justifyContent="end">
                    <IconButton component={Link} size="large" edge="end" color="inherit" aria-label="menu" to={AppRoutes.SETTINGS}>
                        <MenuIcon />
                    </IconButton>
                </Stack>
            </DesktopMenuContainer>
        </DesktopMenuWrapper>
    );
};

export default DesktopMenu;
